import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";
import { ResendVerificationEmail } from "~/app/(new)/(global)/verify-email-failure/components";

export const Route = createFileRoute("/verify-email-failure")({
  component: VerifyEmailFailurePage,
});

function VerifyEmailFailurePage() {
  // if we get here, then the verify email failed
  return (
    <GlobalShell>
      <ResendVerificationEmail />
    </GlobalShell>
  );
}
